/** Reserve space for send footer so overlays do not clip the input border */
export const COPILOT_SEND_FOOTER_HEIGHT = 92;

export const COPILOT_SEND_ICON_DATA_URI =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffffff'%3E%3Cpath d='M3.4 20.4 22 12 3.4 3.6l1.6 6.4L16 12 5 12l-1.6 6.4z'/%3E%3C/svg%3E\")";

export const COPILOT_CHAT_WAITING_CLASS = 'copilot-chat-waiting';
